enum FactorEnum {
    DEVICE = "DEVICE",
    ENCRYPTION_KEY = "ENCRYPTION_KEY",
    OTP = "OTP",
    PASSWORD = "PASSWORD",
    SECURITY_CODE = "SECURITY_CODE",
    SECURITY_QUESTION = "SECURITY_QUESTION"
}

export default FactorEnum;
